import * as $ from 'jquery';
import 'bootstrap';
import 'selectize';

export class helpTopics {
	private $helpTopics = $('.helptopic');
	private $topFaq = $('.topfaq');

	onLoadHandler(): any {
		let _self = this;
		let searchStr = window.location.search.substring(1);
		let searchParams = searchStr.split('&');
		let targetParam = 'targetHelpId';
		let accordionTarget:any;
		let accordionLink:any;
		let accordionPos:any;

		for (var i=0; i<searchParams.length; i++) {
			let val = searchParams[i].split("=");
			if (val[0] == targetParam) {
				// console.log(val[1]);
				accordionLink   = _self.$topFaq.find('a[href="#'+val[1]+'"]');
				accordionTarget = _self.$topFaq.find('#'+val[1]);
				accordionPos    = accordionLink.offset().top;

				// console.log(accordionLink, accordionTarget, accordionPos);
			}
		}

		if (accordionLink !== undefined) {
			$('body').animate({
				scrollTop: accordionPos - 100
			}, 600, function(){
				setTimeout(() => {
					accordionLink.trigger('click');
					// accordionTarget.collapse('show')
				}, 400);
			});
			// accordionTarget.collapse('show');
		} else return false;
	}

	initLinkHandler(): any {
		let _self = this;
		let link: any = _self.$helpTopics.find('.subtopic__item a');

		link.each((i:number, el:any) => {

			let linkType:string = el.dataset.type;
			let linkUrl:any;
			let linkAccordion:any;

			switch (linkType) {
				case 'accordion':
					linkAccordion = el.dataset.accordionTarget;
					_self.accordionHandler(el, linkAccordion);
				break;
				case 'redirect':
					linkUrl = el.dataset.url;
					_self.redirectHandler(el, linkUrl);
				break;
				default:
				break;
			}
		});
	}

	/**
	 * [accordionHandler description]
	 * on clicking link, find target accordion and scroll to it, opening
	 * the accordion once auto-scroll has completed.
	 * @param  {any}    el        [element]
	 * @param  {string} linkType  [target link]
	 * @param  {string} linkAccordion [description]
	 */
	accordionHandler(el:any, linkAccordion:string):any {
		let _self = this;

		$(el).on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			let accordionLink   = _self.$topFaq.find('a[href="'+linkAccordion+'"]');
			let accordionTarget = _self.$topFaq.find(linkAccordion);
			let accordionPos    = accordionLink.offset().top;

			$('body').animate({
				scrollTop: accordionPos - 100
			}, 600, function(){
				setTimeout(() => {
					accordionLink.trigger('click');
					// accordionTarget.collapse('show')
				}, 400);
			});
		})
	}

	/**
	 * [redirectHandler description]
	 * redirect to new page based on relative url when clicked
	 * @param  {any}    el      [element]
	 * @param  {string} linkUrl [target url]
	 */
	redirectHandler(el:any, linkUrl:string):any {
		let _self = this;

		$(el).on('click', (e:any) => {
			e.preventDefault();
			e.stopPropagation();

			window.location.href = window.location.origin + linkUrl;
		})
	}
}

let scopeHelpTopic:Element = document.querySelector('.helptopic');
let scopeTopfaqs:Element = document.querySelector('.topfaq');
let helptopics = new helpTopics();

if (scopeHelpTopic){
	try {
		helptopics.initLinkHandler();
	} catch(e) {console.error(e);}
}

if (scopeTopfaqs){
	try {
		helptopics.onLoadHandler();
	} catch(e) {console.error(e);}
}

